const scrollListener = (scrollContainer: HTMLElement | Document = document) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  let resolveRef: () => void;

  const createHandler = (cb: () => void) => () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      cb();
    }, 150);
  };

  const startListening = () => {
    const handler = createHandler(() => {
      scrollContainer.removeEventListener('scroll', handler);
      resolveRef?.();
    });
    scrollContainer.addEventListener('scroll', handler);
  };

  const onScrollEnd = () =>
    new Promise<void>((resolve) => {
      resolveRef = resolve;
    });

  return {
    startListening,
    onScrollEnd,
  };
};

export async function scrollToTop<T extends HTMLElement | null>(element: T) {
  const { startListening, onScrollEnd } = scrollListener();

  if (!element) {
    return;
  }

  const rect = element.getBoundingClientRect();

  if (rect.top >= 0) {
    return;
  }

  startListening();

  element.scrollIntoView({
    block: 'start',
    inline: 'start',
    behavior: 'smooth',
  });

  await onScrollEnd();
}
